<template>
  <div>
    <h1 class="display-4 font-weight-lighter">
      How To's
    </h1>

    <b-alert show>Below are videos outlining how to navigate the dealer portal.</b-alert>

    <c-row>
      <c-col xl="4" lg="6" md="12" class="mb-4" v-for="document in documents" :key="document.id">
        <video-preview :document="document"></video-preview>
        <div class="bg-dark p-4 d-block library-card border-top">
          <h3 class="font-weight-bold m-0 p-0">
            <img src="img/brand/sf-logo-mini-white.svg" height="26" class="pr-2">
            <span class="pl-2 font-2xl">{{ document.name }}</span>
          </h3>
          <p v-if="document.description" class="m-0 p-0 pt-3">{{ document.description }}</p>
        </div>
      </c-col>
    </c-row>
  </div>
</template>

<script>

import Document from "../models/Document";
import VideoPreview from "../components/documents/VideoPreview";

export default {
  name: 'CustomerHowToVideos',
  components: {VideoPreview},
  data() {
    return {
      documents: null,
    };
  },
  methods: {
    populate() {
      this.documents = Document.query().where('document_folder_id', Document.getHowToFolderId).get();
    },
    fetch() {
      return Document.api().fetch({document_folder_id: Document.getHowToFolderId, limit: 99});
    },
  },
  mounted() {
    this.fetch().then(() => {
      this.populate();
    })
  }
}
</script>
